import {
  STOCK_CONFIRM_IMPORT_BEGIN,
  STOCK_CONFIRM_IMPORT_SUCCESS,
  STOCK_CONFIRM_IMPORT_PARTIALLY_SUCCESS,
  STOCK_CONFIRM_IMPORT_FAILURE,
  STOCK_CONFIRM_IMPORT_DISMISS_ERROR,
} from './constants'
import { BFFAgent } from '../../../common/BFFAgent'
import * as FileSaver from 'file-saver';
import { XML_TYPE } from 'Utilities';

export function confirmImport() {
  return async (dispatch, getState) => {
    const { stock: { stockToProcess, summary, stocks, fileName } } = getState();

    dispatch({
      type: STOCK_CONFIRM_IMPORT_BEGIN,
    });

    try {
      const fileBuffer = await BFFAgent.Stock.confirmStockImportation(
        { stockToProcess, summary, stocks, fileName, isSummary: false }
      );
      if(fileBuffer) {
        // Genero una URL temporal
        const file = new Blob([fileBuffer],
          {
            type: XML_TYPE,
          }
        )
        // Descargo el archivo
        FileSaver.saveAs(file, 'DetalleImportacionStock.xlsx')
        dispatch({
          type: STOCK_CONFIRM_IMPORT_SUCCESS,
        });
      } else {
        dispatch({
          type: STOCK_CONFIRM_IMPORT_PARTIALLY_SUCCESS,
        });
      }
        
    } catch(error) {
      dispatch({
        type: STOCK_CONFIRM_IMPORT_FAILURE,
        data: { error }
      }); 
    }

  }
}

export function dismissConfirmImportError() {
  return {
    type: STOCK_CONFIRM_IMPORT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_CONFIRM_IMPORT_BEGIN:
      return {
        ...state,
        confirmImportPending: true,
        confirmImportError: null,
        confirmImportSuccess: false,
      }

    case STOCK_CONFIRM_IMPORT_SUCCESS:
      return {
        ...state,
        confirmImportPending: false,
        confirmImportSuccess: true,
      }
    case STOCK_CONFIRM_IMPORT_PARTIALLY_SUCCESS:
      return {
        ...state,
        confirmImportPending: false,
        confirmImportSuccess: true,
        confirmImportPartiallySuccess: true,
      }
    case STOCK_CONFIRM_IMPORT_FAILURE:
      return {
        ...state,
        confirmImportPending: false,
        confirmImportError: action.data.error,
      }
    case STOCK_CONFIRM_IMPORT_DISMISS_ERROR:
      return {
        ...state,
        confirmImportError: null
      }

    default:
      return state
  }
}
